<template>
  <div
    :data-component-name="$options.name"
    :class="[jel_getClassObject(content)]"
    class="h-100 mb-5"
  >
    <div v-if="salles" class="content-bingo-majeur ctn-shadow">
      <div
        class="img-gagnant-container img-gagnant-container-border"
        :style="{ 'border-color': salle ? salle.couleurClair : 'black' }"
      >
        <div class="svg-wrapper">
          <div class="img-gagnant">
            <svg
              class="d-flex"
              :fill="salle ? salle.couleurClair : 'black'"
              data-name="Troph�e"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 50 50"
            >
              <title>trophe_noir</title>
              <path
                class="fill-to-change"
                d="M48.84,5.43a.67.67,0,0,0-.67-.64H41.25V1a.66.66,0,0,0-.67-.66H9.12A.66.66,0,0,0,8.45,1V4.79H1.82a.67.67,0,0,0-.67.64,36.16,36.16,0,0,0,1.28,9.91C4.35,22.27,8.18,27,13.54,29.06a16.44,16.44,0,0,0,10.52,4.53v6.13H11.91a2.55,2.55,0,0,0-2.53,2.53v6.8a.66.66,0,0,0,.67.66H38.88a.65.65,0,0,0,.66-.66v-6.8A2.55,2.55,0,0,0,37,39.72H25.39V33.59a16.24,16.24,0,0,0,10.69-4.45h0a.69.69,0,0,0,.24-.05c5.4-2.05,9.29-6.82,11.21-13.77A34.68,34.68,0,0,0,48.84,5.43ZM30.35,15.1l-2.21,2.16.53,3a.62.62,0,0,1-.26.64.82.82,0,0,1-.4.13.72.72,0,0,1-.32-.08L25,19.55,22.25,21a.64.64,0,0,1-.69,0,.61.61,0,0,1-.27-.64l.53-3L19.64,15.1a.72.72,0,0,1-.16-.69A.64.64,0,0,1,20,14l3-.46,1.36-2.77a.61.61,0,0,1,.58-.37.64.64,0,0,1,.59.37l1.36,2.77L30,14a.64.64,0,0,1,.53.45A.66.66,0,0,1,30.35,15.1Zm-27.87-9h6V17.21a16.41,16.41,0,0,0,2.85,9.22C3.17,21.12,2.51,9.05,2.48,6.12Zm35.7,20.65a16.22,16.22,0,0,0,3.09-9.56V6.12h6.24C47.48,9.11,46.79,21.66,38.18,26.77Z"
              />
            </svg>
          </div>
        </div>
      </div>
      <div class="gagnant-txt-content">
        <div class="gagnant-pseudo graphik_bold">{{ pseudo }}</div>
        <div
          :style="{ 'background-color': salle ? salle.couleurClair : 'inherit' }"
          class="gagnant-money graphik_bold"
        >
          <money-format
            :value="montantGain"
            :locale="$i18n.locale + '-CA'"
            currency-code="CAD"
            :subunit-value="true"
          ></money-format>
        </div>
        <div class="gagnant-info">
          <div v-if="salle">{{ salle.titre }}</div>
          <div v-else>{{ $t('messageComponent.salleInconnue') }}</div>
          <div>{{ dateGainFormat }}</div>
        </div>
        <div v-if="salle" class="container-btn-gagnant graphik_bold">
          <b-link class="button" @click="launchBingo()">
            {{ $t('messageComponent.jouer') }}
          </b-link>
        </div>
        <div v-else class="container-salle-inconnue"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MoneyFormat from 'vue-money-format';
import moment from 'moment-timezone';
import i18n from '@/js/i18n';
import session from '@/services/api/compte/session';

export default {
  name: 'BingoGagnantMajeur',
  components: {
    'money-format': MoneyFormat,
  },
  props: { content: { type: Object, required: true } },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          jouer: 'Jouer',
          salleInconnue: 'Salle inconnue',
        },
      },
      en: {
        messageComponent: {
          jouer: 'Play',
          salleInconnue: 'Unknown room',
        },
      },
    },
  },
  computed: {
    ...mapGetters('bingo', ['getSalle', 'getSalleByIdSalleNyx']),

    pseudo() {
      return this.content.gagnant[0];
    },
    montantGain() {
      return this.content.gagnant[1];
    },
    idSalleNyx() {
      return this.content.gagnant[2];
    },
    dateGain() {
      return this.content.gagnant[3];
    },
    salle() {
      return this.getSalleByIdSalleNyx(this.idSalleNyx);
    },
    salles() {
      return this.getSalle(null);
    },
    dateGainFormat() {
      return moment(this.dateGain).format('YYYY-MM-DD');
    },
    lobbyLinkRoute() {
      return this.$store.getters['routes/getRouteByPath']('/jel/bingo/lobby');
    },
  },
  updated() {
    // eslint-disable-next-line no-undef
    if (session.sessionEstOuverte()) {
      const idSalle = sessionStorage.getItem('idSalle');
      if (idSalle) {
        // eslint-disable-next-line no-undef
        if (!/anon/i.test(ejConnect.etatClient)) {
          // eslint-disable-next-line no-undef
          if (/(ci|cl)/i.test(ejConnect.etatClient)) {
            this.ouvrirModaleConfirmationCICL();
          } else {
            this.launchBingo(idSalle);
          }
        }
      }
    }
  },
  created() {
    moment.locale(i18n.locale);
    this.$store.dispatch('bingo/initSalles');
  },
  methods: {
    ouvrirModaleConfirmationCICL() {
      this.$bvModal.show('modale-confirmation-ci-cl');
    },
    launchBingo(salleId = null) {
      // Si la session est ouverte, on retourne l'url du Lobby Bingo
      const idSalle = salleId ?? this.salle['@name'];
      if (!session.sessionEstOuverte()) {
        /*
         * On ajoute 'idSalle' dans le sessionStorage
         * pour lancer automatiquement la Salle de Bingo après le login
         */
        // On test si le bouton de connexion Auth0 est actif
        if (process.env.VUE_APP_CIAM_ENABLED === 'true') {
          sessionStorage.setItem('idSalle', idSalle);
          // eslint-disable-next-line no-undef
          lancerConnexionAuth0(this.$i18n.locale, window.location.href);
        } else {
          // eslint-disable-next-line no-undef
          ejConnect.ouvrirModaleLogin();
        }
        // eslint-disable-next-line no-undef
      } else if (/(ci|cl)/i.test(ejConnect.etatClient)) {
        this.ouvrirModaleConfirmationCICL();
      } else {
        this.jel_ouvrirFenetre(
          `/${this.$i18n.locale}${this.lobbyLinkRoute['@path']}?idSalle=${idSalle}`,
          'Bingo',
          'yes',
          'yes',
          'no'
        );
        sessionStorage.removeItem('idSalle');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content-bingo-majeur {
  padding: 5%;
  border-radius: ms(2);
  width: 92.5%;
  background-color: white;

  .img-gagnant-container {
    width: 5rem;
    height: 5rem;
    position: relative;
    bottom: 50px;
    left: calc(50% + -2.5rem);
    display: inline-block;
    background: white;
  }

  .img-gagnant-container-border {
    border-style: solid;
    border-width: 2px;
    border-radius: 50%;
  }

  .svg-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  .img-gagnant {
    width: 60%;
  }

  .gagnant-txt-content {
    margin-top: -15%;

    *:not(.gagnant-info, .gagnant-money) {
      display: flex;
      justify-content: center;
    }

    .gagnant-pseudo {
      font-size: ms(0);
      text-transform: uppercase;
    }

    .gagnant-money {
      font-size: ms(1);
      font-weight: bold;
      margin: 0.5rem 0;
      padding: 0.5rem 0;
      width: 120%;
      margin-left: -10%;
      color: black;
    }

    .gagnant-info {
      font-size: ms(0);
    }

    .container-btn-gagnant {
      margin: 1rem 0 0 0;

      .button {
        border: 2px solid #00ca91;
        border-radius: ms(2);
        padding: 0.5rem 25%;
        color: black;
        font-weight: bold;
        font-size: ms(-1);
        text-transform: uppercase;
        text-decoration: none;
      }
    }

    .container-salle-inconnue {
      margin: 1.75rem;
    }
  }
}
</style>
